// extracted by mini-css-extract-plugin
var _1 = "MainContainer__main--Hb_wO";
export { _1 as "main" }
